export default __webpack_public_path__ + "img/0e18c7d00c7c2a6709f3c5fdbbbc5c67.png";